// src/components/ChatComposer.jsx
import React, { useEffect, useRef } from "react";

export default function ChatComposer({ value, onChange, onSend, loading }) {
  const textareaRef = useRef(null);

  // Auto-resize logic
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 200) + "px";
  }, [value]);

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  }

  // Force focus back after loading
  useEffect(() => {
    if (!loading && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [loading]);

  return (
    // PARENT WRAPPER (Previously 'composer')
    <div className="w-full shrink-0 z-10 px-5 pb-4 bg-transparent">
      
      {/* BOX CONTAINER (Previously '.composer-box') 
          - Updated colors to match Home.jsx theme
          - Retained the shadow, rounded corners, and padding-bottom for actions
      */}
      <div className="
        relative w-full 
        bg-[#2F2D28] border border-[#7A8065] 
        rounded-2xl p-3.5 pb-12
        shadow-[0_8px_30px_rgba(0,0,0,0.04)]
        transition-all duration-200
        focus-within:shadow-[0_8px_30px_rgba(111,165,142,0.15)] 
        focus-within:border-[#8FB996]
      ">
        
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
          rows={1}
          disabled={loading}
          // TEXTAREA STYLES (Previously '.composer-box textarea')
          className="
            w-full resize-none border-none outline-none 
            bg-transparent 
            text-[#ECE7D5] placeholder-[#B8B2A1]
            text-[15px] leading-[22px]
            max-h-[200px] overflow-y-auto
            focus:ring-0
          "
        />

        {/* ACTIONS BAR (Previously '.composer-actions') */}
        <div className="absolute bottom-2 left-3 right-3 flex justify-between items-center">
          
          {/* ICON BUTTON (Previously '.icon-btn') */}
          <button 
            className="
              flex items-center justify-center w-8 h-8 rounded-full 
              text-[#7A8065] hover:bg-white/5 transition-colors
              text-xl
            "
          >
            ＋
          </button>

          {/* SEND BUTTON (Previously '.send-btn') 
              - Used your Green Theme (#6FA58E) instead of the neon green
          */}
          <button 
            onClick={onSend} 
            disabled={loading || !value.trim()} 
            className="
              bg-[#6FA58E] hover:bg-[#7FBFA3] text-[#1F2A24]
              rounded-[10px] px-3.5 py-1.5 
              text-base font-medium
              transition-transform active:scale-95
              disabled:bg-[#4A4F40] disabled:text-[#6F7565] disabled:cursor-not-allowed
            "
          >
            {loading ? (
              // Simple loading dots
              <span className="animate-pulse">...</span>
            ) : (
              "➤"
            )}
          </button>
        </div>

      </div>
    </div>
  );
}